import { render, staticRenderFns } from "./index.vue?vue&type=template&id=16043608&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=16043608&scoped=true&lang=css&"
import style1 from "./style.less?vue&type=style&index=1&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "16043608",
  null
  
)

export default component.exports